/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Features_TitleInputs */

const es_home_features_title = /** @type {(inputs: Home_Features_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Características principales`)
};

const en_home_features_title = /** @type {(inputs: Home_Features_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key features`)
};

/**
* | output |
* | --- |
* | "Key features" |
*
* @param {Home_Features_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_features_title = /** @type {((inputs?: Home_Features_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Features_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_features_title(inputs)
	return en_home_features_title(inputs)
});
export { home_features_title as "home.features.title" }